import { Globals } from '../../../modules/Globals';
import axios from 'axios';
import { TTaxpayerLookupResult } from '@/interfaces/ITaxpayerLookup';

const apiUrl = Globals.apiPath + '/invoicing/afip';

export default class AfipTaxpayerService {
  constructor() {}

  static async lookup(cuit: string): Promise<TTaxpayerLookupResult> {
    const res = await axios.get<TTaxpayerLookupResult>(
      `${apiUrl}/taxpayer/${encodeURIComponent(cuit)}`
    );
    return res.data;
  }
}
